import { Injectable } from '@angular/core';

/** Estado de layout compartilhado entre o shell e os filhos (nav, header). */
@Injectable()
export class V2ShellLayoutStore {
    isMobile = false;
    isDesktop = false;
    isCollapsed = false;

    private closeSidenavFn?: () => void;

    registerCloseSidenav(fn: () => void): void {
        this.closeSidenavFn = fn;
    }

    closeSidenav(): void {
        this.closeSidenavFn?.();
    }
}
